import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { Country } from "../types";

export const updateCountryApi = (userId: string, country: Country) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "listing/updcnt",
    params: {
      userId,
    },
    data: country,
  });

export default updateCountryApi;
